import React, { Children, memo } from 'react';
import { Container } from './ui/Container';
import { PenTool, Heart, Users } from 'lucide-react';
export function HowItWorks() {
  return <section id="how-it-works" className="py-20 bg-white" data-id="element-45">
      <Container data-id="element-46">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-47">
          <h2 className="text-4xl font-serif text-[#2D2D2D] mb-6" data-id="element-48">
            How the Program Works
          </h2>
          <p className="text-lg text-[#555555]" data-id="element-49">
            Our process is intentionally analog. We prioritize depth and
            thoughtfulness over speed, using offline methods to encourage
            genuine reflection.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-50">
          <div className="flex flex-col items-center text-center" data-id="element-51">
            <div className="w-16 h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center mb-6 text-[#3D5A4C]" data-id="element-52">
              <PenTool size={32} strokeWidth={1.5} data-id="element-53" />
            </div>
            <h3 className="text-2xl font-serif text-[#2D2D2D] mb-4" data-id="element-54">
              Offline Reflection
            </h3>
            <p className="text-[#555555] leading-relaxed" data-id="element-55">
              Children write paper-and-pencil essays
              with prompts distributed in schools. This disconnect from digital
              noise allows for deeper, more focused expression.
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-56">
            <div className="w-16 h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center mb-6 text-[#3D5A4C]" data-id="element-57">
              <Heart size={32} strokeWidth={1.5} data-id="element-58" />
            </div>
            <h3 className="text-2xl font-serif text-[#2D2D2D] mb-4" data-id="element-59">
              Guided Connection
            </h3>
            <p className="text-[#555555] leading-relaxed" data-id="element-60">
              We provide structured school-approved prompts that guide participants to think
              about the meaning of fatherhood, specific memories, and hopes for
              the future.
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-61">
            <div className="w-16 h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center mb-6 text-[#3D5A4C]" data-id="element-62">
              <Users size={32} strokeWidth={1.5} data-id="element-63" />
            </div>
            <h3 className="text-2xl font-serif text-[#2D2D2D] mb-4" data-id="element-64">
              Community Recognition
            </h3>
            <p className="text-[#555555] leading-relaxed" data-id="element-65">
              Selected reflections are shared within the school community and
              local channels, celebrating positive fatherhood as a community pillar.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}